import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Select, InputX, LayerBottom, Button } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const HomeModify = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [showConfirm, setShowConfirm] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openConfirm = () => {
		setShowConfirm(true)
	}

	const closeConfirm = () => {
		setShowConfirm(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding pt_0">
				<div className="flex-justify_end">
					<span className="link-top" style={{ color: "#999" }} onClick={openConfirm}>삭제</span>
				</div>
				<div className={`${styles["home-address"]} pt_30`}>경기 성남시 분당구 판교역로 235</div>
				<div className={`${styles["home-title"]} mt_5`}>에이치스퀘어 N차</div>
				<div className={`${styles["tag-area"]} mt_10`}>
					<i className="tag tag-box tag-gray normal">아파트</i>
					<i className="tag tag-box tag-gray normal">매매</i>
				</div>

				<div className="flex-align_center mt_40">
					<p className="guide-title">전용면적</p>
					<i className="icon icon_question ml_10" onClick={openLayer} />
				</div>
				<Select title="전용면적 선택" className="mt_10" selected={1} data={[
					{ key: "76.26㎡", value: 0 },
					{ key: "97.94㎡", value: 1 },
					{ key: "107.95㎡", value: 2 },
					{ key: "170.69㎡", value: 3 },
				]} onSelect={(key, value) => {
					console.log(key, value)
				}}>
				</Select>

				<p className="guide-title mt_40">매매 금액</p>
				<div className="form-group mt_10">
					<InputX type="text" id="" placeholder="구입 당시 금액" defaultValue="72,000" className="withMag" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>만원</span>
				</div>
			</div>

			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">정보 수정하기</Button>
			</div>

			<DetailTip show={showLayer} closeLayer={closeLayer}>
				혹시 찾는 전용면적이 없으신가요?<br />
				최근 6개월 내 실거래가 일어나지 않은 전용면적은 나오지 않아요.
				모니 부동산은 국토교통부 실거래가 API를 활용하여 아파트, 오피스텔 및 연립/다세대 정보를 제공하고 있어요.
			</DetailTip>
			
			<ConfirmLayer show={showConfirm} closeLayer={closeConfirm} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<div className="btn-group">
				<Button className="btn btn--big btn-layer btn--gray" onClick={() => closeLayer()}>아니요</Button>
				<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>네</Button>
			</div>
		}>
			<div className="layer-text py_10">
				등록한 내 집을 삭제하시겠습니까?
			</div>
		</LayerBottom>
	)
}

export default HomeModify